/*
 Pagination
  
 historia: 
  PM 2021-12-14 - start
*/

import * as React from "react";
import { Theme, withStyles, WithStyles, FormControl, Grid, Button, Select, OutlinedInput, MenuItem } from '@material-ui/core';
import Klawiatura from "./Klawiatura";
import { WithTranslation, withTranslation } from "react-i18next";
import SpaceBarIcon from '@mui/icons-material/SpaceBar';
import SearchIcon from '@mui/icons-material/Search';


interface PaginationProps extends WithStyles<typeof styles> {
    range: number[],
    page: number,
    updateSkip: (aPage: number) => void,
    resultsPerPage: number,
    tableLength: number,
    changeResultsPerPage: (event: React.ChangeEvent<{
        name?: string;
        value: unknown;
    }>) => void
}

export const calculateRange = (data: number, rowsPerPage: number) => {
    const range = [];
    const num = Math.ceil(data / rowsPerPage);

    for (let i = 1; i <= num; i++) {
        range.push(i);
    }
    return range;
};

interface PaginationState {
    strona: number;
    openKlawiatura: boolean;
}
class Pagination extends React.Component<PaginationProps & WithTranslation, PaginationState> {

    constructor(props: PaginationProps & WithTranslation) {
        super(props, {});

        this.state = {
            strona: 0,
            openKlawiatura: false,

        }

       
    }

    openKlawiatura = () => {
        this.setState({openKlawiatura: true})
    }
    closeKlawiatura = () => {
        this.setState({openKlawiatura: false})
    }
    setStrona = (field: string, value: any, shouldValidate?: boolean | undefined) => {
        let v = Number(value);
        if(v < 1) v = 1; 
        if(v > this.props.range.length) v = this.props.range.length;
        this.props.updateSkip(v)
    }

    //PM 2021-12-21 zrezygnowano
    // hidden = (range: number) => {
    //     if (range === 1 || range === this.props.range.length)
    //         return false
    //     else if ((this.props.page - range) > 2)
    //         return true
    //     else if ((range - this.props.page) > 2)
    //         return true
    //     else
    //         return false
    // }

    //PM 2021-12-21 zrezygnowano
    // wielokropek = (range: number) => {
    //     if (range === 1 || range === this.props.range.length)
    //         return false
    //     else if ((this.props.page - range) === 3)
    //         return true
    //     else if ((range - this.props.page) === 3)
    //         return true
    //     else
    //         return false
    // }

    //PM 2021-12-21
    outOfRange = (page: number) => page <= 1 || page >= this.props.range.length

    //PM 2021-12-21
    checkRange = (aMiddleButtons: [number, number, number, number]) => aMiddleButtons.map(mB => this.outOfRange(mB) ? -1 : mB)

    //PM 2021-12-21
    middleButtons = () => {
        let middleButtons: number[] = [ -1, -1, -1, -1]

        if (this.props.page >= 1 && this.props.page <= 4)
            middleButtons = [2, 3, 4, 5]
        else if (this.props.page >= (this.props.range.length - 3) && this.props.page <= this.props.range.length)
            middleButtons = [ this.props.range.length - 4, this.props.range.length - 3, this.props.range.length - 2, this.props.range.length - 1]
        else
            middleButtons = [this.props.page - 2, this.props.page - 1, this.props.page, this.props.page + 1]

        middleButtons = this.checkRange(middleButtons)   
        //if(this.props.range.length > 9){
        //    middleButtons = [...middleButtons.slice(0, 2), 9999, ...middleButtons.slice(2)];
        //} 
        return middleButtons
    }

    //PM 2021-12-21
    //stala szerokosc paginacji
    render = () => {
        const { classes, t } = this.props;
        const middleButtons = this.middleButtons();

        if(this.props.resultsPerPage > this.props.tableLength)
            return (<></>)
        else
        return (
            <div className={classes.container} style={{ width: '100%', marginTop: "15px" }}>
                <FormControl component="fieldset" variant="outlined" fullWidth margin='normal'>
                    <Grid container direction="row" alignItems='center' justifyContent="center">
                        <Grid item className={classes.gridButton}>
                            <Button
                                className={`${classes.input} ${classes.seagreen}`}
                                variant="outlined" color="primary"
                                onClick={() => this.props.updateSkip(this.props.page - 1)}
                                disabled={this.props.page !== 1 ? false : true}
                            >
                                {this.props.page !== 1 ? '<' : ''}
                            </Button>
                        </Grid>
                        <Grid item className={classes.gridButton}>
                            <Button
                                className={`${classes.input} ${this.props.page === 1 ? classes.primaryBackground : classes.seagreen}`}
                                variant="outlined" color="primary"
                                onClick={() => this.props.updateSkip(1)}
                            >
                                1
                            </Button>
                        </Grid>
                        {middleButtons.includes(-1)? "" : "..."}
                        {middleButtons.map(mB => {
                            const disabled = mB < 0
                            if(disabled)
                                return (null)
                            // else if(mB === 9999)   
                            //     return (
                            //         <Grid item className={classes.gridButton}>
                            //             <Button
                            //                 className={`${classes.input} ${classes.seagreen}`}
                            //                 style={{height: "45.2px"}}
                            //                 variant="outlined" color="primary"
                            //                 onClick={() => this.openKlawiatura()}
                            //             >                          
                            //                 <SearchIcon/>
                            //             </Button>
                            //         </Grid>
                            //     )
                            else    
                                return (
                                    <Grid item className={classes.gridButton}>
                                        <Button
                                            className={`${classes.input} ${this.props.page === mB ? classes.primaryBackground : classes.seagreen}`}
                                            variant="outlined" color="primary"
                                            onClick={() => this.props.updateSkip(mB)}
                                            disabled={disabled}
                                        >
                                            {disabled ? '' : mB}
                                        </Button>
                                    </Grid>
                                )
                        })}
                        {middleButtons.includes(-1)? "" : "..."}
                        {this.props.resultsPerPage < this.props.tableLength ?
                            <Grid item className={classes.gridButton}>
                                <Button
                                    className={`${classes.input} ${this.props.page === this.props.range.length ? classes.primaryBackground : classes.seagreen}`}
                                    variant="outlined" color="primary"
                                    onClick={() => this.props.updateSkip(this.props.range.length)}
                                >
                                    {this.props.range.length}
                                </Button>
                            </Grid> : null}
                        <Grid item className={classes.gridButton}>
                            <Button
                                className={`${classes.input} ${classes.seagreen}`}
                                variant="outlined" color="primary"
                                onClick={() => this.props.updateSkip(this.props.page + 1)}
                                disabled={this.props.page !== this.props.range.length ? false : true}
                            >
                                {this.props.page !== this.props.range.length ? '>' : ''}
                            </Button>
                        </Grid>
                        {this.props.range.length > 9 ? 
                            <Grid item className={classes.gridButton}>
                                <Button
                                    className={`${classes.input} ${classes.seagreen}`}
                                    style={{ height: "45.2px" }}
                                    variant="outlined" color="primary"
                                    onClick={() => this.openKlawiatura()}
                                >
                                    <SearchIcon />
                                </Button>
                            </Grid>
                        : null }    
                    </Grid>
                    
                </FormControl>

                <Klawiatura open={this.state.openKlawiatura} number={this.state.strona} setNumber={this.setStrona} fieldName={"abc"} close={this.closeKlawiatura} title={t("wpisz numer strony")} />
                
                {/* {range(1, (this.props.tableLength + 1) / 2, 1).map(d => ( */}
                {/* <FormControl variant="outlined" margin="normal" className={classes.formControl}>
                    <Grid container direction="row" alignItems='center' justifyContent="center">
                        <Grid item>
                            <label className={classes.label}>
                                wyników na stronę:
                            </label>
                            <Select
                                value={this.props.resultsPerPage}
                                onChange={this.props.changeResultsPerPage}
                                classes={{ selectMenu: classes.left, icon: classes.icon}}
                                input={<OutlinedInput labelWidth={0} />}
                            >
                                
                                {[3,5,10,15,20,25,50].map(d => (
                                    <MenuItem
                                        key={d} value={d}
                                    >
                                        {d}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </Grid>
                </FormControl> */}
            </div>
        )
    }
}

const styles = (theme: Theme) => ({
    container: {
        margin: 'auto',
    },
    gridButton: {
        margin: '5px'
    },
    input: {
        border: "2px solid lavender",
        borderRadius: "0px",
        fontSize: "14px",
        lineHeight: "14px",
        fontWeight: "bold" as "bold",
        padding: "14px 0px",
        minWidth: '48px',
        minHeight: '44px',
        "&:hover": {
            border: "2px solid lavender",
            background: "#2c9993", //"#007000",
            color: 'white',
        },
    },
    primaryBackground: {
        color: "white",
        backgroundColor: 'lightseagreen',//theme.palette.primary.main,
    },
    seagreen: {
        color: 'lightseagreen',//'seagreen',
    },
    label: {
        //fontFamilly: "sans-serif",
        //fontSize: "small"
        color: 'lightseagreen',//theme.palette.text.secondary,
        fontSize: "12px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: theme.typography.body2.fontWeight,
        padding: "0px",
        marginRight: '11.296px',
        display: "initial" as "initial"
    },
    left: {
        color: 'lightseagreen',//theme.palette.primary.main,
        fontSize: "14px",
        fontWeight: "bold" as "bold",
        textAlign: "left" as "left"
    },
    formControl: {
        display: "block",
        //paddingBottom: "35px"
    },
    icon: {
        width: "24px",
        height: "24px",
    }
});

//export default withStyles(styles)(Pagination);
export default withTranslation()(withStyles(styles)(Pagination));


export const range = (start: number, end: number, step: number) => {
    let range: number[] = [];
  
    if (step === 0) {
      throw TypeError("Step cannot be zero.");
    }
  
    if (end < start) {
      step = -step;
    }
  
    while (step > 0 ? end >= start : end <= start) {
      range.push(start);
      start += step;
    }
  
    return range;
  
  }
  